import { useEffect, useRef, useState } from 'react';

import Image from '@/components/image';
import useOnClickOutside from '@/hooks/useOnClickOutside';
import { event_button_click, event_installment_option } from '@/utils/gtm';
import InstallmentText from './InstallmentText';
import TabbyModal from './tabby-modal';

export function truncateToTwoDecimalPlaces(number) {
  const formattedNumber = Number(number?.toFixed(2));
  return formattedNumber.toFixed(2);
}
const TabbyWidget = ({ amount, locale, buttonLocation }) => {
  const [show, setShow] = useState(false);
  const refModel = useRef();
  const refBtn = useRef();

  useOnClickOutside([refModel, refBtn], () => setShow(false));

  useEffect(() => {
    if (show) {
      event_installment_option({ merchant_name: 'tabby' });
      event_button_click({
        button_name: 'Tabby',
        button_destination: 'open_bnpl_info',
        button_location: buttonLocation,
      });
    }
  }, [show, buttonLocation]);

  return (
    <div className='border-border flex min-h-[55px] items-center rounded-md border bg-white px-1'>
      <div
        ref={refBtn}
        className='flex items-center'
        onClick={() => setShow((show) => !show)}
      >
        <Image
          src={`/imgs/payments/tabby_installments.png`}
          alt='tabby logo'
          width={85}
          height={28}
          className='h-[28px] w-[85px] object-contain'
        />
        <InstallmentText
          {...{
            locale,
            payNum: 4,
            mainPrice: truncateToTwoDecimalPlaces(amount / 4) || '',
            onClick: () => null,
          }}
        />
      </div>
      {show ? <TabbyModal {...{ locale, setShow, total: amount }} /> : null}
    </div>
  );
};
export default TabbyWidget;
